/**
 * GDPR-compliant tracker loader.
 * Google Analytics, Meta Pixel and PostHog only load AFTER user consent.
 */

const CONSENT_KEY = 'valuare-cookie-consent';
const GA_ID = 'G-0RQ44YHNYE';
const FB_PIXEL_ID = '1994874864546951';
const POSTHOG_KEY = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = 'https://us.i.posthog.com';

let trackersLoaded = false;

const loadGoogleAnalytics = () => {
  if (window.gtag) return;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID);
};

const loadMetaPixel = () => {
  if (window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', FB_PIXEL_ID);
  window.fbq('track', 'PageView');
  /* eslint-enable */
};

const loadPostHog = () => {
  if (window.posthog && window.posthog.__loaded) return;
  /* eslint-disable */
  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            });
        }
        ((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src =
            s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
            "/static/array.js"),
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog";
              return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e;
            },
            o = "init capture identify reset register unregister opt_in_capturing opt_out_capturing".split(" "),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);
  window.posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    session_recording: {
      recordCrossOriginIframes: true,
      capturePerformance: false,
    },
  });
  /* eslint-enable */
};

export const loadTrackers = () => {
  if (trackersLoaded) return;
  trackersLoaded = true;
  try {
    loadGoogleAnalytics();
    loadMetaPixel();
    loadPostHog();
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[Tracking] Failed to load:', err);
    }
  }
};

export const initTrackersIfConsented = () => {
  if (typeof window === 'undefined') return;
  // NOTE: localStorage is used ONLY for the GDPR consent flag ('accepted' | 'declined').
  // No personal data or credentials are stored here. This is the standard
  // approach for cookie consent banners and is safe from XSS concerns.
  const consent = localStorage.getItem(CONSENT_KEY);
  if (consent === 'accepted') {
    loadTrackers();
  }
};
